import { journeyAction, settingsFormSchema } from "./base";
import { JourneyActionCallBack as JourneyActionCallBackBase } from "atlas-shared";

export const JourneyActionCallBack = journeyAction({
  ...JourneyActionCallBackBase,
  settings_form: settingsFormSchema({
    elements: [{ ref: "queue_id" }],
  }),
  icon: "Voice",
});
